import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Handshake, CreditCard, ShoppingCart, Gavel, Scale } from 'lucide-react';
const modules = [{
  icon: <BookOpen className="w-6 h-6" data-id="element-126" />,
  title: 'Fundamentos Prácticos de Defensa del Consumidor',
  desc: 'Ley explicada en la práctica, principios protectores, deber de información, trato digno y responsabilidad.'
}, {
  icon: <Handshake className="w-6 h-6" data-id="element-127" />,
  title: 'Reclamos Administrativos y Estrategias Extrajudiciales',
  desc: 'Cómo iniciar, negociar y resolver conflictos de consumo.'
}, {
  icon: <CreditCard className="w-6 h-6" data-id="element-128" />,
  title: 'Bancos, Tarjetas, Fintech y Estafas Digitales',
  desc: 'Consumos desconocidos, phishing, billeteras virtuales y fraudes electrónicos.'
}, {
  icon: <ShoppingCart className="w-6 h-6" data-id="element-129" />,
  title: 'Compras Online, Marketplaces y Servicios',
  desc: 'Compras electrónicas, incumplimientos, servicios públicos, telefonía e internet.'
}, {
  icon: <Gavel className="w-6 h-6" data-id="element-130" />,
  title: 'Demandas Judiciales y Medidas Cautelares',
  desc: 'Cómo estructurar demandas, solicitar cautelares y fortalecer el reclamo.'
}, {
  icon: <Scale className="w-6 h-6" data-id="element-131" />,
  title: 'Jurisprudencia, Daños y Estrategias Procesales',
  desc: 'Daño moral, daño punitivo, jurisprudencia aplicada y criterios actuales.'
}];
export const Modules = () => {
  return <section className="py-12 bg-legal-800 border-y border-legal-700" data-id="element-132">
      <div className="container mx-auto px-4" data-id="element-133">
        <div className="text-center mb-10 max-w-3xl mx-auto" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-135">
            ¿Qué incluye el Tratado?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto space-y-4" data-id="element-136">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="group flex gap-5 md:gap-6 bg-legal-900 border border-legal-700 hover:border-gold-500/50 rounded-xl p-6 md:p-7 transition-colors" data-id="element-137">
              {/* Number + icon */}
              <div className="shrink-0 flex flex-col items-center" data-id="element-138">
                <span className="font-serif text-4xl md:text-5xl font-bold text-gold-500/30 leading-none group-hover:text-gold-500/60 transition-colors" data-id="element-139">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="mt-3 flex items-center justify-center w-11 h-11 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-140">
                  {mod.icon}
                </span>
              </div>

              <div className="border-l border-legal-700 pl-5 md:pl-6" data-id="element-141">
                <span className="text-xs font-semibold tracking-widest uppercase text-gold-500/80" data-id="element-142">
                  Módulo {idx + 1}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mt-1 mb-2 leading-snug" data-id="element-143">
                  {mod.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-144">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};